export const iconFontAwesomeUsersPeoplePersonBiking = (
	<i className="fa-solid fa-person-biking"></i>
);
